import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    tile: 'bg-grey-90 hover:(b-brand-2 c-brand-2)',
  }
} satisfies VfConfig['tile']
